type TContentMode = 'readThresholds' | 'writeThresholds'

interface IImportFilterStatus {
    cls: string
    icon: string
    msg: string
    status: 'offuntil' | 'off' | 'on'
}